export enum Role {
  Patient = 'Patient',
  Clinician = 'Clinician',
  ClinicAdmin = 'ClinicAdmin',
  GlobalAdmin = 'GlobalAdmin'
}
